import React from "react";
import { ListTitle, SubTitle } from "./style";

const ProfileList = ({ title, subtitle, list, className }) => (
  <article className={className}>
    <header>
      <ListTitle>{title}</ListTitle>
      <SubTitle>{subtitle}</SubTitle>
    </header>
    <ul>{list()}</ul>
  </article>
);

export default ProfileList;



// WEBPACK FOOTER //
// ./src/components/ProfileList/index.js